import { useState } from "react";

export default () => {
 
    return <div className="loader">
       <div className="loader__figure"></div>   
  </div>
};
